export default __webpack_public_path__ + "static/media/check_notification.f139a13b.svg";